export const GET_INVOICES_SUCCESS = 'invoices/GET_INVOICES_SUCCESS';
export const GET_INVOICE_SUCCESS = 'invoices/GET_INVOICE_SUCCESS';
export const CLEAR_SELECTED_INVOICE = 'invoices/CLEAR_SELECTED_INVOICE';
export const GET_CURRENT_INVOICE_SUCCESS = 'invoices/GET_CURRENT_INVOICE_SUCCESS';
export const CLEAR_INVOICES = 'invoices/CLEAR_INVOICES';